import { Box } from '@flos/react-ui';
import DOMPurify from 'dompurify';

const CoverableDetailsTemplate = ({
    header,
    subheader,
    children
}: {
    header?: string;
    subheader?: string;
    children: React.JSX.Element | React.JSX.Element[];
}): React.JSX.Element => {
    return (
        <Box padding="large" className="u-spacing-stack-l">
            {header && <h4>{header}</h4>}
            {subheader && (
                <p
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(subheader, {
                            ALLOWED_TAGS: ['br', 'b', 'u']
                        })
                    }}
                />
            )}
            {children}
        </Box>
    );
};

export default CoverableDetailsTemplate;
